<template>
  <div class="home">
    <div class="world-bg"> 绿色全友 温馨世界 </div>
  </div>
</template>
<script>
export default {
  name: 'Home'
}
</script>
<style lang="stylus" scoped>
  .home
    width auto
    height calc(100% - 10px)
    background #fff
    margin 5px
    .world-bg
      background: url(../../assets/home-bg.png) no-repeat;
      width 100%
      height 100%
      background-size 80% auto
      background-position 50%
      text-align center
      line-height 45
      letter-spacing 10px
      color #24c69a
      font-size 18px
</style>
